var addMarker, addMarkers, arrayAerial, arrayOSM, baseAerial, baseOSM, center, clearMap, current, currentMarker, currentPopup, deletePOIMarker, displayOsmMapContent, emap, emarkers, event, genericMarkers, getCoordinates, googleMap, highlight, map, markerArray, markerKeyPairs, markerclusterer, markers, markersArray, reInitIcon, renderMarkers, renderOSMMarkers, renderTimeout, selectCtrl;

map = void 0;

emap = void 0;

googleMap = void 0;

arrayOSM = void 0;

arrayAerial = void 0;

baseOSM = void 0;

baseAerial = void 0;

markers = void 0;

emarkers = void 0;

current = "";

markerArray = [];

renderTimeout = null;

event = void 0;

selectCtrl = void 0;

genericMarkers = [];

markersArray = [];

currentPopup = void 0;

currentMarker = void 0;

highlight = void 0;

markerKeyPairs = [];

markerclusterer = void 0;

center = void 0;


/*
An array with information of all POIs which have been fetched.
 */


/*
Initializes the OSM maps.
 */

reInitIcon = function(link) {};


/*
Adds a marker to OSM Maps
Arguments
lat - The Latitude of the marker.
lon - The longitude of the marker.
info - Pop Content (HTML formatted).
link - Marker Icon url.
 */

addMarkers = function(lat, lng, info, link, key, id) {};


/*
Gets Markers from the structure and adds them to OSM Map
 */

renderOSMMarkers = function() {};

displayOsmMapContent = function(id) {};


/*
Clears the OSM map markers
 */

clearMap = function() {};


/*
Adds a generic marker to the Array for rendering later.
 */

addMarker = function(gm, row_id, id) {};

deletePOIMarker = function(id, row_id) {};


/*
Converts a POINT(12.929878 77.600877) to individual Longitude & Latitude
 */

getCoordinates = function(point) {};

renderMarkers = function() {};

//# sourceMappingURL=maps/maps.js.map
